import React, { lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
// Routing
import Routing from "../../pages/franchise/router/router";
import Loadable from "../../router/loadable";
import RobotsTxtViewer from "../../robotsPage";
// Components
import Header from "../../common/restuarant/header/header";
const GoTop = Loadable(lazy(() => import("../../common/takeaway/gototop/gototop")));
const ScrollToTop = Loadable(lazy(() => import("../../common/takeaway/scrolltop/scrolltop")));
const Sitemap = Loadable(lazy(() => import("../../common/takeaway/pages/Sitemap")));
// const AppLink = Loadable(lazy(() => import("../../common/Link/Link")));
const FeedBack = Loadable(lazy(() => import("../../common/feedBack/feedBack")));

const Franchise = (params) => {
  return (
    <>
      <Router basename={"/"}>
        <Routes>
          <Route path="/"
            element={
              <>
                <ScrollToTop />
                <Header />
                <Routing />
                <GoTop />
                <FeedBack />
              </>
            }
          />
          <Route path="/sitemap.xml" element={<Sitemap />} />
          <Route path="/robots.txt" element={<RobotsTxtViewer />} />
          <Route path="/*"
            element={
              <>
                <ScrollToTop />
                <Header />
                <Routing />
                <GoTop />
                <FeedBack />
              </>
            }
          />
        </Routes>
      </Router>
    </>
  );
};
export default Franchise;
